import { useEffect, useState } from "react";
import { Col, Form, FormFeedback, Input, Label, Row } from "reactstrap";
import { useCommonDataFindAllQuery, useMeasurementHydropowerCreateMutation, useMeasurementHydropowerFindAllQuery, useMeasurementHydropowerUpdateMutation } from "store";
import * as Yup from "yup";
import { useFormik } from "formik";
import Spinners from "Components/Common/Spinner";
import { Link, useParams } from "react-router-dom";
import Switch from "react-switch";
import measurementSvg from "../../../assets/images/svg/measurement.svg"
import Flatpickr from "react-flatpickr";


const Measurement = () => {
  const { id } = useParams();
  const [isLoading, setLoading] = useState(true)
  const { data, error, isFetching } = useMeasurementHydropowerFindAllQuery(`?hydropower_id=${id}`);
  const [measurementHydropowerCreate, measurementHydropowerCreateResult] = useMeasurementHydropowerCreateMutation();
  const [measurementHydropowerUpdate, measurementHydropowerUpdateResult] = useMeasurementHydropowerUpdateMutation();
  const [measurementHydropower, setMeasurementHydropower] = useState<any>();

  const [measurementList, setMeasurementList] = useState<any>();

  const [meaCount, setMeaCount] = useState<any>();

  const [is_used, setIs_usedBoolean] = useState<boolean>(false);
  const [is_newCreated, setIs_newCreated] = useState<boolean>(false);
  const [submitBoolean, set_submitBoolean] = useState<boolean>(false);


  useEffect(() => {
    if (measurementHydropower === undefined) {
      setLoading(true);
    } else {
      setLoading(false);
    }
    setMeasurementList(data?.data);
    setMeaCount(data?.data?.length)
    const tempIs_used = measurementHydropower !== null ? measurementHydropower?.is_used : false;
    setIs_usedBoolean(tempIs_used)

  }, [id, data, measurementHydropower, submitBoolean])


  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      id: measurementHydropower?.id,
      hydropower_id: measurementHydropower?.hydropower_id,
      hydropower_code: measurementHydropower?.hydropower_code,
      measure_date: measurementHydropower?.measure_date,
      // is_clean: is_used === undefined ? false : is_used,

      usage_information: measurementHydropower?.usage_information,
      installed_capacity: measurementHydropower?.installed_capacity,
      energy_production_annual: measurementHydropower?.energy_production_annual,
      pool_volume_total: measurementHydropower?.pool_volume_total,
      pool_volume_used: measurementHydropower?.pool_volume_used,
      pool_volume_unused: measurementHydropower?.pool_volume_unused,
      pool_area_normal: measurementHydropower?.pool_area_normal,
      pool_area_use: measurementHydropower?.pool_area_use,
      heatstroke_Ntah: measurementHydropower?.heatstroke_Ntah,
      heatstroke_Nt: measurementHydropower?.heatstroke_Nt,
      heatstroke_calculate: measurementHydropower?.heatstroke_calculate,
      river_flow_average: measurementHydropower?.river_flow_average,
      river_flow_P01: measurementHydropower?.river_flow_P01,
      river_flow_P1: measurementHydropower?.river_flow_P1,
      river_flow_P5: measurementHydropower?.river_flow_P5,
      turbine_type_output: measurementHydropower?.turbine_type_output,
      turbine_type_speed: measurementHydropower?.turbine_type_speed,
      turbine_type_wheeldiameter: measurementHydropower?.turbine_type_wheeldiameter,
      generator_type: measurementHydropower?.generator_type,
      generator_voltage: measurementHydropower?.generator_voltage,
      port_type: measurementHydropower?.port_type,

      port_design: measurementHydropower?.port_design,
      port_length: measurementHydropower?.port_length,
      port_heigth: measurementHydropower?.port_heigth,
      derivation_canal_length: measurementHydropower?.derivation_canal_length,
      derivation_design: measurementHydropower?.derivation_design,
      heatstroke_pipe_diameter: measurementHydropower?.heatstroke_pipe_diameter,
      turbine_type: measurementHydropower?.turbine_type,
      capacity: measurementHydropower?.capacity,
      floodwater_canal_design: measurementHydropower?.floodwater_canal_design,
      dam_length: measurementHydropower?.dam_length,
      investment_per_energy_mnt: measurementHydropower?.investment_per_energy_mnt,
      investment_per_energy_usd: measurementHydropower?.investment_per_energy_usd,
      registred_date: measurementHydropower?.registred_date,
      registred_position: measurementHydropower?.registred_position,

      report_autor: measurementHydropower?.report_autor,
      report_name: measurementHydropower?.report_name,
      report_code: measurementHydropower?.report_code,

    },
    validationSchema: Yup.object({
      hydropower_code: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      measure_date: Yup.date().typeError("Он сар өдөр оруулна уу").required("Утга оруулна уу !"),

      usage_information: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      installed_capacity: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      energy_production_annual: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      pool_volume_total: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      pool_volume_used: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      pool_volume_unused: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      pool_area_normal: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      pool_area_use: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      heatstroke_Ntah: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      heatstroke_Nt: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      heatstroke_calculate: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      river_flow_average: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      river_flow_P01: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      river_flow_P1: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      river_flow_P5: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      turbine_type_output: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      turbine_type_speed: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      turbine_type_wheeldiameter: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      generator_type: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      generator_voltage: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      port_type: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),

      port_design: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      port_length: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      port_heigth: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      derivation_canal_length: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      derivation_design: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      heatstroke_pipe_diameter: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      turbine_type: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      capacity: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      floodwater_canal_design: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      dam_length: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      investment_per_energy_mnt: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      investment_per_energy_usd: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),

      report_autor: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      report_name: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      report_code: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
    }),
    onSubmit: (values: any) => {
      if (is_newCreated === false) {
        const updateList = {
          id: measurementHydropower?.id,
          hydropower_id: measurementHydropower?.hydropower_id,
          hydropower_code: values?.hydropower_code,
          measure_date: values?.measure_date,
          is_used: is_used === undefined ? false : is_used,

          usage_information: values?.usage_information,
          installed_capacity: values?.installed_capacity,
          energy_production_annual: values?.energy_production_annual,
          pool_volume_total: values?.pool_volume_total,
          pool_volume_used: values?.pool_volume_used,
          pool_volume_unused: values?.pool_volume_unused,
          pool_area_normal: values?.pool_area_normal,
          pool_area_use: values?.pool_area_use,
          heatstroke_Ntah: values?.heatstroke_Ntah,
          heatstroke_Nt: values?.heatstroke_Nt,
          heatstroke_calculate: values?.heatstroke_calculate,
          river_flow_average: values?.river_flow_average,
          river_flow_P01: values?.river_flow_P01,
          river_flow_P1: values?.river_flow_P1,
          river_flow_P5: values?.river_flow_P5,
          turbine_type_output: values?.turbine_type_output,
          turbine_type_speed: values?.turbine_type_speed,
          turbine_type_wheeldiameter: values?.turbine_type_wheeldiameter,
          generator_type: values?.generator_type,
          generator_voltage: values?.generator_voltage,
          port_type: values?.port_type,

          port_design: values?.port_design,
          port_length: values?.port_length,
          port_heigth: values?.port_heigth,
          derivation_canal_length: values?.derivation_canal_length,
          derivation_design: values?.derivation_design,
          heatstroke_pipe_diameter: values?.heatstroke_pipe_diameter,
          turbine_type: values?.turbine_type,
          capacity: values?.capacity,
          floodwater_canal_design: values?.floodwater_canal_design,
          dam_length: values?.dam_length,
          investment_per_energy_mnt: values?.investment_per_energy_mnt,
          investment_per_energy_usd: values?.investment_per_energy_usd,
          registred_date: values?.registred_date,
          registred_position: values?.registred_position,

          report_autor: values?.report_autor,
          report_name: values?.report_name,
          report_code: values?.report_code,

        }

        measurementHydropowerUpdate(updateList);
      } else {
        const newList = {
          hydropower_id: id,
          hydropower_code: values["hydropower_code"],
          measure_date: values["measure_date"],
          is_used: is_used === undefined ? false : is_used,

          usage_information: values["usage_information"],
          installed_capacity: values["installed_capacity"],
          energy_production_annual: values["energy_production_annual"],
          pool_volume_total: values["pool_volume_total"],
          pool_volume_used: values["pool_volume_used"],
          pool_volume_unused: values["pool_volume_unused"],
          pool_area_normal: values["pool_area_normal"],
          pool_area_use: values["pool_area_use"],
          heatstroke_Ntah: values["heatstroke_Ntah"],
          heatstroke_Nt: values["heatstroke_Nt"],
          heatstroke_calculate: values["heatstroke_calculate"],
          river_flow_average: values["river_flow_average"],
          river_flow_P01: values["river_flow_P01"],
          river_flow_P1: values["river_flow_P1"],
          river_flow_P5: values["river_flow_P5"],
          turbine_type_output: values["turbine_type_output"],
          turbine_type_speed: values["turbine_type_speed"],
          turbine_type_wheeldiameter: values["turbine_type_wheeldiameter"],
          generator_type: values["generator_type"],
          generator_voltage: values["generator_voltage"],
          port_type: values["port_type"],

          port_design: values["port_design"],
          port_length: values["port_length"],
          port_heigth: values["port_heigth"],
          derivation_canal_length: values["derivation_canal_length"],
          derivation_design: values["derivation_design"],
          heatstroke_pipe_diameter: values["heatstroke_pipe_diameter"],
          turbine_type: values["turbine_type"],
          capacity: values["capacity"],
          floodwater_canal_design: values["floodwater_canal_design"],
          dam_length: values["dam_length"],
          investment_per_energy_mnt: values["investment_per_energy_mnt"],
          investment_per_energy_usd: values["investment_per_energy_usd"],
          registred_date: values["registred_date"],
          registred_position: values["registred_position"],

          report_autor: values["report_autor"],
          report_name: values["report_name"],
          report_code: values["report_code"],
        };

        measurementHydropowerCreate(newList)
      }
      // validation.resetForm();
    },
  });

  const Offsymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Үгүй
      </div>
    );
  };

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Тийм
      </div>
    );
  };

  return (

    <>


      <Row>
        <Col lg={12}>
          <div className="d-flex align-items-center mb-3">
            <img src={measurementSvg} alt="" height="50" />
            <div className="flex-grow-1 ms-3">
              <h5 className="fw-semibold">Мэдээлэл</h5>
              <ul className="list-unstyled hstack gap-2 mb-0">
                <li>
                  <i className="mdi mdi-table-row-height"></i>{" "}
                  <span className="text-muted fw-semibold">
                    Нийт: {meaCount}
                  </span>
                </li>
              </ul>
            </div>

            <button
              type="button"
              disabled={is_newCreated === true ? true : false}
              className="btn btn-success  btn-label"
              onClick={() => {
                validation.resetForm();
                setMeasurementHydropower(null);
                setIs_usedBoolean(false);
                setIs_newCreated(true);
              }}
            >
              <i className="mdi mdi-file-plus-outline label-icon"></i>
              Шинээр нэмэх
            </button>

          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={3}>
          <ul className="verti-timeline list-unstyled">
            {measurementList?.map((item, index) => (
              <li className="event-list active">
                <div className="event-timeline-dot">
                  <i className="bx bxs-right-arrow-circle font-size-18 bx-fade-right" />
                </div>
                <div className="flex-shrink-0 d-flex">
                  <div key={index} className="d-flex mb-3">
                    <div className="me-3">
                      <h5 className="font-size-14">
                        {item?.created_at.split("T")[0]}
                        <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                      </h5>
                    </div>
                    <div className="flex-grow-1">
                      <div>
                        <Link
                          to="#"
                          className="cursor fw-semibold"
                          onClick={() => {
                            setIs_newCreated(false)
                            set_submitBoolean(false)
                            setMeasurementHydropower(item)
                          }}
                        >
                          {item?.measure_date}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </Col>
        <Col lg={9}>
          {
            isLoading ? <Spinners setLoading={setLoading} sCustomTop={'120px'} /> :
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  set_submitBoolean(true)
                  validation.handleSubmit();
                  return false;
                }}
              >
                <Row>
                  <Col lg={4}>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Код </Label>
                      <Input
                        name="hydropower_code"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.hydropower_code || ""}
                        invalid={
                          validation.touched.hydropower_code &&
                            validation.errors.hydropower_code
                            ? true
                            : false
                        }
                      />
                      {validation.touched.hydropower_code &&
                        validation.errors.hydropower_code ? (
                        <FormFeedback type="invalid">
                          {validation.errors.hydropower_code}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Ашиглалтын талаарх мэдээлэл  </Label>
                      <Input
                        name="usage_information"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.usage_information || ""}
                        invalid={
                          validation.touched.usage_information &&
                            validation.errors.usage_information
                            ? true
                            : false
                        }
                      />
                      {validation.touched.usage_information &&
                        validation.errors.usage_information ? (
                        <FormFeedback type="invalid">
                          {validation.errors.usage_information}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Усан сангийн эзэлхүүн Нийт км3 </Label>
                      <Input
                        name="pool_volume_total"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.pool_volume_total || ""}
                        invalid={
                          validation.touched.pool_volume_total &&
                            validation.errors.pool_volume_total
                            ? true
                            : false
                        }
                      />
                      {validation.touched.pool_volume_total &&
                        validation.errors.pool_volume_total ? (
                        <FormFeedback type="invalid">
                          {validation.errors.pool_volume_total}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Усан сангийн талбай -Хэвийн үед км2 </Label>
                      <Input
                        name="pool_area_normal"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.pool_area_normal || ""}
                        invalid={
                          validation.touched.pool_area_normal &&
                            validation.errors.pool_area_normal
                            ? true
                            : false
                        }
                      />
                      {validation.touched.pool_area_normal &&
                        validation.errors.pool_area_normal ? (
                        <FormFeedback type="invalid">
                          {validation.errors.pool_area_normal}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Түрэлт - Нт,п  </Label>
                      <Input
                        name="heatstroke_Nt"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.heatstroke_Nt || ""}
                        invalid={
                          validation.touched.heatstroke_Nt &&
                            validation.errors.heatstroke_Nt
                            ? true
                            : false
                        }
                      />
                      {validation.touched.heatstroke_Nt &&
                        validation.errors.heatstroke_Nt ? (
                        <FormFeedback type="invalid">
                          {validation.errors.heatstroke_Nt}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Голын урсац-Р=0.1 % хангамшилтай үед м3/сек </Label>
                      <Input
                        name="river_flow_P01"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.river_flow_P01 || ""}
                        invalid={
                          validation.touched.river_flow_P01 &&
                            validation.errors.river_flow_P01
                            ? true
                            : false
                        }
                      />
                      {validation.touched.river_flow_P01 &&
                        validation.errors.river_flow_P01 ? (
                        <FormFeedback type="invalid">
                          {validation.errors.river_flow_P01}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Турбины төрөл - гаралтын чадал квт </Label>
                      <Input
                        name="turbine_type_output"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.turbine_type_output || ""}
                        invalid={
                          validation.touched.turbine_type_output &&
                            validation.errors.turbine_type_output
                            ? true
                            : false
                        }
                      />
                      {validation.touched.turbine_type_output &&
                        validation.errors.turbine_type_output ? (
                        <FormFeedback type="invalid">
                          {validation.errors.turbine_type_output}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Генератор төрөл - тооцоот чадал квт</Label>
                      <Input
                        name="generator_type"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.generator_type || ""}
                        invalid={
                          validation.touched.generator_type &&
                            validation.errors.generator_type
                            ? true
                            : false
                        }
                      />
                      {validation.touched.generator_type &&
                        validation.errors.generator_type ? (
                        <FormFeedback type="invalid">
                          {validation.errors.generator_type}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Боомтын хийц, зохиомж </Label>
                      <Input
                        name="port_design"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.port_design || ""}
                        invalid={
                          validation.touched.port_design &&
                            validation.errors.port_design
                            ? true
                            : false
                        }
                      />
                      {validation.touched.port_design &&
                        validation.errors.port_design ? (
                        <FormFeedback type="invalid">
                          {validation.errors.port_design}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Деривацын суваг урт, м (км)  </Label>
                      <Input
                        name="derivation_canal_length"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.derivation_canal_length || ""}
                        invalid={
                          validation.touched.derivation_canal_length &&
                            validation.errors.derivation_canal_length
                            ? true
                            : false
                        }
                      />
                      {validation.touched.derivation_canal_length &&
                        validation.errors.derivation_canal_length ? (
                        <FormFeedback type="invalid">
                          {validation.errors.derivation_canal_length}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Турбины төрөл  </Label>
                      <Input
                        name="turbine_type"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.turbine_type || ""}
                        invalid={
                          validation.touched.turbine_type &&
                            validation.errors.turbine_type
                            ? true
                            : false
                        }
                      />
                      {validation.touched.turbine_type &&
                        validation.errors.turbine_type ? (
                        <FormFeedback type="invalid">
                          {validation.errors.turbine_type}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Урт м  </Label>
                      <Input
                        name="dam_length"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.dam_length || ""}
                        invalid={
                          validation.touched.dam_length &&
                            validation.errors.dam_length
                            ? true
                            : false
                        }
                      />
                      {validation.touched.dam_length &&
                        validation.errors.dam_length ? (
                        <FormFeedback type="invalid">
                          {validation.errors.dam_length}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Тайлан гаргасан</Label>
                      <Input
                        name="report_autor"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.report_autor || ""}
                        invalid={
                          validation.touched.report_autor &&
                            validation.errors.report_autor
                            ? true
                            : false
                        }
                      />
                      {validation.touched.report_autor &&
                        validation.errors.report_autor ? (
                        <FormFeedback type="invalid">
                          {validation.errors.report_autor}
                        </FormFeedback>
                      ) : null}
                    </div>


                  </Col>

                  <Col lg={4}>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Хэмжилт хийсэн огноо </Label>
                      <Flatpickr
                        className="form-control d-block"
                        placeholder="Огноо"
                        name="measure_date"
                        value={validation.values.measure_date}
                        onChange={(selectDate: Date[]) => {
                          if (selectDate[0]) {
                            const localDate = new Date(selectDate[0].getTime() - selectDate[0].getTimezoneOffset() * 60000)
                              .toISOString()
                              .split('T')[0];
                            validation.setFieldValue('measure_date', localDate);
                          }
                        }}
                        options={{
                          altInput: true,
                          altFormat: "Y-m-d",
                          dateFormat: "Y-m-d",
                          enableTime: false,
                        }}
                      />

                      {validation.touched.measure_date &&
                        validation.errors.measure_date ? (
                        <FormFeedback type="invalid">
                          {validation.errors.measure_date}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Суурилагдсан хүчин чадал Р </Label>
                      <Input
                        name="installed_capacity"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.installed_capacity || ""}
                        invalid={
                          validation.touched.installed_capacity &&
                            validation.errors.installed_capacity
                            ? true
                            : false
                        }
                      />
                      {validation.touched.installed_capacity &&
                        validation.errors.installed_capacity ? (
                        <FormFeedback type="invalid">
                          {validation.errors.installed_capacity}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Усан сангийн эзэлхүүн Хэрэглэгдэх км3</Label>
                      <Input
                        name="pool_volume_used"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.pool_volume_used || ""}
                        invalid={
                          validation.touched.pool_volume_used &&
                            validation.errors.pool_volume_used
                            ? true
                            : false
                        }
                      />
                      {validation.touched.pool_volume_used &&
                        validation.errors.pool_volume_used ? (
                        <FormFeedback type="invalid">
                          {validation.errors.pool_volume_used}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Усан сангийн талбай - Ашиглалтын үед</Label>
                      <Input
                        name="pool_area_use"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.pool_area_use || ""}
                        invalid={
                          validation.touched.pool_area_use &&
                            validation.errors.pool_area_use
                            ? true
                            : false
                        }
                      />
                      {validation.touched.pool_area_use &&
                        validation.errors.pool_area_use ? (
                        <FormFeedback type="invalid">
                          {validation.errors.pool_area_use}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Түрэлт - Тооцоот </Label>
                      <Input
                        name="heatstroke_calculate"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.heatstroke_calculate || ""}
                        invalid={
                          validation.touched.heatstroke_calculate &&
                            validation.errors.heatstroke_calculate
                            ? true
                            : false
                        }
                      />
                      {validation.touched.heatstroke_calculate &&
                        validation.errors.heatstroke_calculate ? (
                        <FormFeedback type="invalid">
                          {validation.errors.heatstroke_calculate}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Голын урсац-Р=1.0% хангамшилтай үед м3/сек </Label>
                      <Input
                        name="river_flow_P1"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.river_flow_P1 || ""}
                        invalid={
                          validation.touched.river_flow_P1 &&
                            validation.errors.river_flow_P1
                            ? true
                            : false
                        }
                      />
                      {validation.touched.river_flow_P1 &&
                        validation.errors.river_flow_P1 ? (
                        <FormFeedback type="invalid">
                          {validation.errors.river_flow_P1}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold">Турбины төрөл - хурд   эргэлт/мин </Label>
                      <Input
                        name="turbine_type_speed"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.turbine_type_speed || ""}
                        invalid={
                          validation.touched.turbine_type_speed &&
                            validation.errors.turbine_type_speed
                            ? true
                            : false
                        }
                      />
                      {validation.touched.turbine_type_speed &&
                        validation.errors.turbine_type_speed ? (
                        <FormFeedback type="invalid">
                          {validation.errors.turbine_type_speed}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold">Генератор төрөл - хүчдэл квт</Label>
                      <Input
                        name="generator_voltage"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.generator_voltage || ""}
                        invalid={
                          validation.touched.generator_voltage &&
                            validation.errors.generator_voltage
                            ? true
                            : false
                        }
                      />
                      {validation.touched.generator_voltage &&
                        validation.errors.generator_voltage ? (
                        <FormFeedback type="invalid">
                          {validation.errors.generator_voltage}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold">Боомтын урт м</Label>
                      <Input
                        name="port_length"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.port_length || ""}
                        invalid={
                          validation.touched.port_length &&
                            validation.errors.port_length
                            ? true
                            : false
                        }
                      />
                      {validation.touched.port_length &&
                        validation.errors.port_length ? (
                        <FormFeedback type="invalid">
                          {validation.errors.port_length}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Хийц зохиомж</Label>
                      <Input
                        name="derivation_design"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.derivation_design || ""}
                        invalid={
                          validation.touched.derivation_design &&
                            validation.errors.derivation_design
                            ? true
                            : false
                        }
                      />
                      {validation.touched.derivation_design &&
                        validation.errors.derivation_design ? (
                        <FormFeedback type="invalid">
                          {validation.errors.derivation_design}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Хүчин чадал </Label>
                      <Input
                        name="capacity"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.capacity || ""}
                        invalid={
                          validation.touched.capacity &&
                            validation.errors.capacity
                            ? true
                            : false
                        }
                      />
                      {validation.touched.capacity &&
                        validation.errors.capacity ? (
                        <FormFeedback type="invalid">
                          {validation.errors.capacity}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> 1квт эрчим хүч үйлдвэрлэхэд зарцуулах хөрөнгө оруулалт  төгрөгөөр </Label>
                      <Input
                        name="investment_per_energy_mnt"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.investment_per_energy_mnt || ""}
                        invalid={
                          validation.touched.investment_per_energy_mnt &&
                            validation.errors.investment_per_energy_mnt
                            ? true
                            : false
                        }
                      />
                      {validation.touched.investment_per_energy_mnt &&
                        validation.errors.investment_per_energy_mnt ? (
                        <FormFeedback type="invalid">
                          {validation.errors.investment_per_energy_mnt}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Тайлангийн нэр</Label>
                      <Input
                        name="report_name"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.report_name || ""}
                        invalid={
                          validation.touched.report_name &&
                            validation.errors.report_name
                            ? true
                            : false
                        }
                      />
                      {validation.touched.report_name &&
                        validation.errors.report_name ? (
                        <FormFeedback type="invalid">
                          {validation.errors.report_name}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>

                  <Col lg={4}>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Ашиглаж байгаа эсэх</Label> <br />
                      <Switch
                        uncheckedIcon={<Offsymbol />}
                        checkedIcon={<OnSymbol />}
                        className="me-1 mb-sm-8 mb-2 ms-3"
                        onColor="#626ed4"
                        onChange={() => {
                          setIs_usedBoolean(!is_used);
                        }}
                        checked={is_used}
                      />
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Жилд үйлдвэрлэх эрчим хүч  </Label>
                      <Input
                        name="energy_production_annual"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.energy_production_annual || ""}
                        invalid={
                          validation.touched.energy_production_annual &&
                            validation.errors.energy_production_annual
                            ? true
                            : false
                        }
                      />
                      {validation.touched.energy_production_annual &&
                        validation.errors.energy_production_annual ? (
                        <FormFeedback type="invalid">
                          {validation.errors.energy_production_annual}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Усан сангийн эзэлхүүн Хэрэглэгдээгүй км3  </Label>
                      <Input
                        name="pool_volume_unused"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.pool_volume_unused || ""}
                        invalid={
                          validation.touched.pool_volume_unused &&
                            validation.errors.pool_volume_unused
                            ? true
                            : false
                        }
                      />
                      {validation.touched.pool_volume_unused &&
                        validation.errors.pool_volume_unused ? (
                        <FormFeedback type="invalid">
                          {validation.errors.pool_volume_unused}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Түрэлт - Нтах </Label>
                      <Input
                        name="heatstroke_Ntah"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.heatstroke_Ntah || ""}
                        invalid={
                          validation.touched.heatstroke_Ntah &&
                            validation.errors.heatstroke_Ntah
                            ? true
                            : false
                        }
                      />
                      {validation.touched.heatstroke_Ntah &&
                        validation.errors.heatstroke_Ntah ? (
                        <FormFeedback type="invalid">
                          {validation.errors.heatstroke_Ntah}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Голын урсац-Дундаж урсац м3/сек </Label>
                      <Input
                        name="river_flow_average"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.river_flow_average || ""}
                        invalid={
                          validation.touched.river_flow_average &&
                            validation.errors.river_flow_average
                            ? true
                            : false
                        }
                      />
                      {validation.touched.river_flow_average &&
                        validation.errors.river_flow_average ? (
                        <FormFeedback type="invalid">
                          {validation.errors.river_flow_average}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Голын урсац-Р=5.0% хангамшилтай үед м3/сек </Label>
                      <Input
                        name="river_flow_P5"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.river_flow_P5 || ""}
                        invalid={
                          validation.touched.river_flow_P5 &&
                            validation.errors.river_flow_P5
                            ? true
                            : false
                        }
                      />
                      {validation.touched.river_flow_P5 &&
                        validation.errors.river_flow_P5 ? (
                        <FormFeedback type="invalid">
                          {validation.errors.river_flow_P5}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Турбины төрөл - дугуйн диаметр м </Label>
                      <Input
                        name="turbine_type_wheeldiameter"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.turbine_type_wheeldiameter || ""}
                        invalid={
                          validation.touched.turbine_type_wheeldiameter &&
                            validation.errors.turbine_type_wheeldiameter
                            ? true
                            : false
                        }
                      />
                      {validation.touched.turbine_type_wheeldiameter &&
                        validation.errors.turbine_type_wheeldiameter ? (
                        <FormFeedback type="invalid">
                          {validation.errors.turbine_type_wheeldiameter}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Боомтын төрөл </Label>
                      <Input
                        name="port_type"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.port_type || ""}
                        invalid={
                          validation.touched.port_type &&
                            validation.errors.port_type
                            ? true
                            : false
                        }
                      />
                      {validation.touched.port_type &&
                        validation.errors.port_type ? (
                        <FormFeedback type="invalid">
                          {validation.errors.port_type}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold">өндөр м </Label>
                      <Input
                        name="port_heigth"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.port_heigth || ""}
                        invalid={
                          validation.touched.port_heigth &&
                            validation.errors.port_heigth
                            ? true
                            : false
                        }
                      />
                      {validation.touched.port_heigth &&
                        validation.errors.port_heigth ? (
                        <FormFeedback type="invalid">
                          {validation.errors.port_heigth}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold">Түрэлтийн хоолойн диаметр </Label>
                      <Input
                        name="heatstroke_pipe_diameter"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.heatstroke_pipe_diameter || ""}
                        invalid={
                          validation.touched.heatstroke_pipe_diameter &&
                            validation.errors.heatstroke_pipe_diameter
                            ? true
                            : false
                        }
                      />
                      {validation.touched.heatstroke_pipe_diameter &&
                        validation.errors.heatstroke_pipe_diameter ? (
                        <FormFeedback type="invalid">
                          {validation.errors.heatstroke_pipe_diameter}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold">Ус хаях сувгийн төрөл, хийц зохиомж </Label>
                      <Input
                        name="floodwater_canal_design"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.floodwater_canal_design || ""}
                        invalid={
                          validation.touched.floodwater_canal_design &&
                            validation.errors.floodwater_canal_design
                            ? true
                            : false
                        }
                      />
                      {validation.touched.floodwater_canal_design &&
                        validation.errors.floodwater_canal_design ? (
                        <FormFeedback type="invalid">
                          {validation.errors.floodwater_canal_design}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold">1квт эрчим хүч үйлдвэрлэхэд зарцуулах хөрөнгө оруулалт  ам. долл</Label>
                      <Input
                        name="investment_per_energy_usd"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.investment_per_energy_usd || ""}
                        invalid={
                          validation.touched.investment_per_energy_usd &&
                            validation.errors.investment_per_energy_usd
                            ? true
                            : false
                        }
                      />
                      {validation.touched.investment_per_energy_usd &&
                        validation.errors.investment_per_energy_usd ? (
                        <FormFeedback type="invalid">
                          {validation.errors.investment_per_energy_usd}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Тайлангийн дугаар </Label>
                      <Input
                        name="report_code"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.report_code || ""}
                        invalid={
                          validation.touched.report_code &&
                            validation.errors.report_code
                            ? true
                            : false
                        }
                      />
                      {validation.touched.report_code &&
                        validation.errors.report_code ? (
                        <FormFeedback type="invalid">
                          {validation.errors.report_code}
                        </FormFeedback>
                      ) : null}
                    </div>

                  </Col>

                  <Col lg={12} className="d-flex justify-content-center mt-3">
                    <button type="submit" disabled={submitBoolean} className="btn btn-primary"> Хадгалах  { }</button>
                  </Col>
                </Row>
              </Form>
          }

        </Col>
      </Row>
    </>
  )
}

export default Measurement;